import {NeoModal} from "@/components/@modal/neo.modal";
import React, {useEffect, useState} from "react";
import toast from "react-hot-toast";

type ModalDataType = {
  id?: number;
  name: string;
  phone?: string;
  address?: string;
};

interface GenericWidgetProps {
  title: string;
  icon: string;
  type: number;
  fetchService: (userId: string) => Promise<any>;
  addService: (data: Record<string, any>, userId: string) => Promise<any>;
  updateService: (data: Record<string, any>, userId: string) => Promise<any>;
  deleteService: (data: Record<string, any>, userId: string) => Promise<any>;
  renderEmptyImage: string;
  emptyText: string;
  actionText: string;
  WidgetContent: React.FC<{
    datas: any[];
    openPopup: (row: Record<string, any>) => void;
    handleDelete: (row: Record<string, any>) => void;
  }>;
  loginUserId: string;
  apiresponsekey: string;
}

const GenericWidget: React.FC<GenericWidgetProps> = ({
  title,
  icon,
  type,
  fetchService,
  addService,
  updateService,
  deleteService,
  renderEmptyImage,
  emptyText,
  actionText,
  WidgetContent,
  loginUserId,
  apiresponsekey
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [checkPopup, setCheckPopup] = useState(false);
  const [hasActions, sethasActions] = useState(false);
  const [modalName, setModalName] = useState("");
  const [modalData, setModalData] = useState<ModalDataType | null>(null);
  const [dataList, setDataList] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);

  const fetchData = async () => {
    try {
      const response = await fetchService(loginUserId);
      if (response?.data?.status === "success" && response?.data?.data) {
        const datas = response.data.data;
        const list = datas[apiresponsekey];
        setDataList(Array.isArray(list) ? list : []);
        setLoader(false);
      }
    } catch {
      toast.error("Sorry! We have a technical issue. Please try again later.");
    }
  };

  useEffect(() => {
    if (checkPopup) {
      setModalName("fleetform");
      setModalOpen(false);
      setModalOpen(true);
    } else {
      setModalOpen(false);
      setModalOpen(false);
    }
  }, [checkPopup]);

  const openPopup = (row: Partial<ModalDataType>) => {
    sethasActions(false);
    setModalOpen(false);
    setModalData(null);
    setCheckPopup(false);
    setTimeout(() => {
      setModalData(row as ModalDataType);
      setCheckPopup(true);
    }, 50);
  };

  const handleFormSubmit = async (data: any) => {
    const isUpdate = Boolean(data?.id);
    const requestData: Record<string, any> = {
      type: type,
      name: data.name,
      phone: data.phone,
      address: data.address
    };
    if (isUpdate) requestData.id = data.id;

    try {
      const response = isUpdate
        ? await updateService(requestData, loginUserId)
        : await addService(requestData, loginUserId);

      if (response?.data?.status === "success") {
        fetchData();
        setModalOpen(false);
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message || "Something went wrong.");
      }
    } catch {
      toast.error("Sorry! We have a technical issue. Please try again later.");
    }
  };

  const handleDelete = (row: Record<string, any>) => {
    setModalData(row as ModalDataType);
    setModalName("delete");
    sethasActions(true);
    setModalOpen(true);
  };

  const handleForDelete = async () => {
    if (modalData?.id) {
      const id = modalData?.id;
      const requestData: any = {
        type: type,
        id: id
      };

      try {
        const response = await deleteService(requestData, loginUserId);
        if (response?.data?.status === "success") {
          fetchData();
          setModalOpen(false);
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message || "Something went wrong.");
        }
      } catch {
        toast.error(
          "Sorry! We have a technical issue. Please try again later."
        );
      }
    }
  };

  useEffect(() => {
    if (loginUserId) fetchData();
  }, [loginUserId]);

  return (
    <div className="rounded-2xl bg-white p-4 shadow-sm">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-lg font-semibold">
          <img src={icon} alt={title} className="h-5 w-5" />
          {title}
        </h2>
        <button
          className="rounded-md bg-black px-4 py-1 text-sm text-white"
          onClick={() => openPopup({})}
        >
          + Add
        </button>
      </div>
      <hr className="-mx-4 mb-2 border-t border-gray-200" />

      {loader ? (
        <div className="flex items-center justify-center">
          <img
            src="/images/loading-lines.webp"
            alt="Loading..."
            className="h-36 w-36 sm:h-24 sm:w-24"
          />
        </div>
      ) : !loader && dataList.length === 0 ? (
        <div className="flex flex-col items-center justify-center p-6">
          <img src={renderEmptyImage} alt="Empty" className="mb-2 h-24" />
          <p className="text-sm text-gray-500">{emptyText}</p>
          <button
            className="mt-1 text-sm font-medium text-blue-600"
            onClick={() => openPopup({})}
          >
            Add {actionText}
          </button>
        </div>
      ) : (
        <div className="mt-1 p-1">
          <WidgetContent
            datas={dataList}
            openPopup={openPopup}
            handleDelete={handleDelete}
          />
        </div>
      )}
      <NeoModal
        onOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        actionType={modalName}
        hasActions={hasActions}
        data={modalData}
        onModalSubmit={!hasActions ? handleFormSubmit : handleForDelete}
        actionText={!hasActions ? actionText : "Yes"}
      />
    </div>
  );
};

export default GenericWidget;
